import { createContext } from "preact";

export const AuthContext = createContext({
  token: "",
  chunkToken: "",
  vesselName: "",
  logout: () => {},
  setAutoLoggedOutBecauseOfToken: () => {},
});
